/* Drawer mobile La Maison du Béret (lmb-).
   Ouverture/fermeture, clic overlay, touche Escape, scroll lock,
   onglets du mega menu, et calage sous la barre d'annonce sticky.
   Aucune dépendance, IDs uniques, pas de conflit avec Dawn. */
(function () {
  'use strict';

  function setBarVar() {
    var bar = document.querySelector('.mdb-marquee');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--lmb-bar-h', h + 'px');
    return h;
  }

  function init() {
    setBarVar();
    window.addEventListener('resize', setBarVar);
    window.addEventListener('load', setBarVar);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setBarVar);
    }

    // Garde-fou robuste : au lieu de deviner quel événement change la hauteur
    // de la barre d'annonce (police, contenu, orientation...), on observe le
    // vrai changement de taille de l'élément et on remet --lmb-bar-h à jour
    // immédiatement, à chaque fois, sans dépendre d'un timing précis.
    var marqueeEl = document.querySelector('.mdb-marquee');
    if (marqueeEl && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        setBarVar();
      });
      ro.observe(marqueeEl);
    }

    var drawer = document.getElementById('lmb-mobile-drawer');
    var overlay = document.getElementById('lmb-drawer-overlay');
    var openBtn = document.getElementById('lmb-drawer-open');
    var closeBtn = document.getElementById('lmb-drawer-close');
    if (!drawer || !overlay || !openBtn || !closeBtn) return;

    var lastFocus = null;

    function isOpen() {
      return drawer.classList.contains('lmb-drawer--open');
    }

    function open() {
      var t = setBarVar();
      drawer.style.top = t + 'px';
      drawer.style.height = 'calc(100vh - ' + t + 'px)';
      overlay.style.top = t + 'px';
      lastFocus = document.activeElement;
      drawer.classList.add('lmb-drawer--open');
      overlay.classList.add('lmb-drawer-overlay--visible');
      document.body.classList.add('lmb-drawer-noscroll');
      openBtn.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('lmb-drawer--open');
      overlay.classList.remove('lmb-drawer-overlay--visible');
      document.body.classList.remove('lmb-drawer-noscroll');
      openBtn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openBtn.addEventListener('click', function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    /* Onglets (mega menu) : boutons [data-lmb-tab] -> panneaux [data-lmb-panel] */
    var tabs = drawer.querySelectorAll('[data-lmb-tab]');
    var panels = drawer.querySelectorAll('[data-lmb-panel]');
    if (tabs.length && panels.length) {
      function activate(id) {
        var i;
        for (i = 0; i < tabs.length; i++) {
          var isActive = tabs[i].getAttribute('data-lmb-tab') === id;
          tabs[i].classList.toggle('lmb-mm-navlink--active', isActive);
          tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
        for (i = 0; i < panels.length; i++) {
          panels[i].hidden = panels[i].getAttribute('data-lmb-panel') !== id;
        }
      }
      for (var i = 0; i < tabs.length; i++) {
        (function (tab) {
          tab.addEventListener('click', function () {
            activate(tab.getAttribute('data-lmb-tab'));
          });
        })(tabs[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
